"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _moment = _interopRequireDefault(require("moment"));

var _formFields = require("@trodly/form-fields");

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

var _membersModule = _interopRequireDefault(require("./styles/members.module.css"));

var _Icons = require("../util/Icons");

var _AutoComplete = _interopRequireDefault(require("../util/AutoComplete"));

var _actions = require("../actions");

var _RegisterEnquiry = _interopRequireDefault(require("./RegisterEnquiry"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CallBack =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CallBack, _React$Component);

  function CallBack(props) {
    var _this;

    _classCallCheck(this, CallBack);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CallBack).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "locationSelect", function (id, value) {
      _this.setState({
        id: id,
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMessageChange", function (value) {
      _this.setState({
        message: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitRequest", function (e) {
      e.preventDefault();

      _this.setState({
        error: false
      });

      var _this$state = _this.state,
          id = _this$state.id,
          value = _this$state.value,
          message = _this$state.message;

      if (id && value && message.length > 10) {
        var _this$props = _this.props,
            userDetails = _this$props.userDetails,
            _registerEnquiry = _this$props.registerEnquiry;

        _this.setState({
          registering: true
        });

        var formData = new FormData(e.target);
        var phone = formData.get("phone");
        var countryCode = formData.get("phone_country_code");
        var user = {
          id: userDetails.id,
          first_name: userDetails.first_name,
          last_name: userDetails.last_name,
          email: userDetails.email,
          phone: phone,
          countryCode: countryCode
        };
        var enquiry = {
          id: id,
          queryType: "locationBased"
        };
        var date = {
          startDate: (0, _moment.default)().unix(),
          dateType: "fixed"
        };
        var members = {
          nrAdults: 1,
          nrChild: 0
        };
        var comment = "".concat(message, ". Call Me");

        _registerEnquiry(enquiry, date, members, comment, null, user);

        _this.setState({
          registered: true
        });
      } else {
        _this.setState({
          error: true
        });
      }
    });

    _this.state = {
      message: "",
      id: "",
      value: "",
      registering: false,
      error: false,
      registered: false
    };
    return _this;
  }

  _createClass(CallBack, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          backButton = _this$props2.backButton,
          userDetails = _this$props2.userDetails;
      var _this$state2 = this.state,
          message = _this$state2.message,
          registering = _this$state2.registering,
          error = _this$state2.error,
          registered = _this$state2.registered;

      if (!userDetails.id) {
        return _react.default.createElement("div", null, "Loading...");
      }

      if (registered) {
        return _react.default.createElement(_RegisterEnquiry.default, null);
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, backButton && _react.default.createElement("button", {
        type: "button",
        className: _baseModule.default.backButton,
        onClick: backButton
      }, _react.default.createElement(_Icons.BackArrow, {
        width: "0.875rem"
      }), _react.default.createElement("span", null, "Back")), _react.default.createElement("form", {
        onSubmit: this.submitRequest,
        className: _baseModule.default.container
      }, error && _react.default.createElement("span", {
        className: _baseModule.default.errorText
      }, "All fields are mandatory"), _react.default.createElement("div", {
        className: _baseModule.default.heading2,
        style: {
          marginBottom: "0.625rem"
        }
      }, "Request a call"), _react.default.createElement("div", {
        className: _baseModule.default.small,
        style: {
          marginBottom: "1.25rem"
        }
      }, "Share your details, this will help us get you the right kind of help."), _react.default.createElement(_formFields.PhoneField, {
        name: "phone",
        required: true,
        value: userDetails.phone || "",
        countryCode: userDetails.countryCode || "92"
      }), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.tiny, " ").concat(_baseModule.default.normalText),
        style: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem"
        }
      }, _react.default.createElement(_Icons.RequestSent, {
        width: "0.875rem",
        color: "#484848"
      }), _react.default.createElement("span", {
        style: {
          marginLeft: "0.25rem"
        }
      }, "Someone from our team will contact you on this number")), _react.default.createElement(_AutoComplete.default, {
        name: "location",
        placeholder: "Travel destination",
        className: "".concat(_baseModule.default.input, " ").concat(_baseModule.default.noMargin),
        dataSrc: "/ajax/vendors/activity/suggestLocation.php",
        onSelect: this.locationSelect
      }), _react.default.createElement("div", {
        className: "".concat(_membersModule.default.messageContainer, " ").concat(_baseModule.default.noMargin)
      }, _react.default.createElement("textarea", {
        value: message,
        onChange: function onChange(e) {
          return _this2.onMessageChange(e.target.value);
        },
        rows: "4",
        placeholder: "Describe your request with full details",
        required: true,
        style: {
          marginTop: "1rem"
        }
      })), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.tiny, " ").concat(_baseModule.default.normalText),
        style: {
          marginTop: "1.25rem"
        }
      }, "Our team will contact you at the earliest, usually that\u2019s within 60 minutes during working hours (Mon to Sat, 9 am to 7 pm)."), _react.default.createElement(_formFields.Button, {
        text: "Send",
        type: "submit",
        primary: true,
        block: true,
        isLoading: registering,
        className: _baseModule.default.callBackButton
      })));
    }
  }]);

  return CallBack;
}(_react.default.Component);

CallBack.defaultProps = {
  backButton: null
};
CallBack.propTypes = {
  backButton: _propTypes.default.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userDetails: state.userDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerEnquiry: function registerEnquiry(enquiry, date, members, comment, source, user) {
      return dispatch((0, _actions.registerEnquiry)(enquiry, date, members, comment, source, user));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallBack);

exports.default = _default;